import React, { useEffect, useState, useRef } from "react";
import { Button, Modal, Box, Chip } from "@mui/material";
import {
  Autocomplete,
  TextField,
  FormControl,
  Select,
  MenuItem,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Checkbox,
  InputLabel,
  Grid,
  IconButton,
  Menu,
  CircularProgress,
} from "@mui/material";
import CircleIcon from "@mui/icons-material/Circle";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {
  getAllFacility,
  getAllFacilityTypes,
  getAllProviders,
  getcopyDataSuperbill,
  getFacilityByProviderId,
  getProviderListByFacility,
  getReportByProvider,
  getSelectedCopyData,
} from "../api/action";
import { useDispatch, useSelector } from "react-redux";
import CustomPagination from "../Utils/CustomPagination";
import * as XLSX from "xlsx";
import CustomTextField from "../Utils/CustomTextfield";
import CloseIcon from "@mui/icons-material/Close";
import SortByAlphaIcon from "@mui/icons-material/SortByAlpha";
import SwapVertIcon from "@mui/icons-material/SwapVert";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";

const CopyDataModal = ({
  open,
  setOpen,
  copyData,
  setCopyData,
  setFilteredData,
  filteredData,
}) => {
  const [selectedRows, setSelectedRows] = useState([]);
  const [searchFacilityCode, setSearchFacilityCode] = useState("");
  const [searchFacilityName, setSearchFacilityName] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedFacility, setSelectedFacility] = useState(null);
  const [dateRange, setDateRange] = useState([null, null]);
  const [updated, setUpdated] = useState(false);
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [providerList, setProviderList] = useState([]);
  const [facilityList, setFacilityList] = useState([]);
  const [facilityTypeList, setFacilityTypeList] = useState([]);
  const [searchProvider, setSearchProvider] = useState(null);
  const [searchFacility, setSearchFacility] = useState(null);
  const [searchFacilityType, setSearchFacilityType] = useState(null);
  // const providerId = localStorage.getItem("userId");
   const providerId = useSelector((state) => state?.user?.userId)
  // const profileId = localStorage.getItem("profileId");
  // const name = localStorage.getItem("userName");
   const name = useSelector((state) => state?.user?.userName)
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [searchFirstName, setSearchFirstName] = useState("");
  const [searchLastName, setSearchLastName] = useState("");
  const [status, setStatus] = useState("");
  // const [filteredData, setFilteredData] = useState([]);
  const [search, setSearch] = useState(false);
  const [counts, setCounts] = useState("");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("");
  const ROWS_PER_PAGE = 50;
  const [selectedFacilities, setSelectedFacilities] = useState([]);
  const [selectedProviders, setSelectedProviders] = useState([]);

  const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
  const checkedIcon = <CheckBoxIcon fontSize="small" />;

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    handleClearSearch();
    setFilteredData([]);
  }, [open]);

  useEffect(() => {
    setSelectedRows([]);
  }, []);

  const formatDate = (date) => {
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const year = date.getFullYear();
    return `${year}-${month}-${day}`;
  };

  useEffect(() => {
    const matchingProvider = providerList.find(
      (provider) => `${provider.First_Name} ${provider.Last_Name}` === name
    );
    if (matchingProvider) {
      setSearchProvider(matchingProvider);
    }
  }, [providerList, name]);

  const dispatch = useDispatch();

  const [startDate, endDate] = dateRange;

  const handleCheckboxChange = (facilityCode) => {
    const isSelected = selectedRows.includes(facilityCode);
    setSelectedRows((prevSelected) =>
      isSelected
        ? prevSelected.filter((code) => code !== facilityCode)
        : [...prevSelected, facilityCode]
    );
  };

  const handleEditClick = (event, selectedFacility) => {
    setAnchorEl(event.currentTarget);
    setSelectedFacility(selectedFacility);
  };

  const handleEditClose = () => {
    setAnchorEl(null);
  };

  // useEffect(() => {
  //     setFilteredData([])
  // }, [])

  useEffect(() => {
    handleSearch();
    setSearch(true);
  }, [updated, currentPage]);

  const handleCopyData = () => {
    const payload = {
      super_biller_ids: selectedRows,
    };

    dispatch(
      getSelectedCopyData(
        payload,
        (data) => {
          setLoading(false);
          // console.log(data?.data, "data")
          setData(data?.data);
          setSelectedRows([]);
          handleClose();
        },
        (error) => {
          console.log(error);
          setLoading(false);
        }
      )
    );
  };

  const handleSearch = () => {
    setFilteredData([]);
    // setSelectAll(false)

    if (
      // selectedFacilities.length === 0 &&
      !searchFacility &&
      !searchFirstName &&
      !searchLastName &&
      !status &&
      !startDate &&
      !endDate &&
      search === true
    ) {
      setSnackbarMessage("Please fill the above field");
      setSnackbarOpen(true);
      setSnackbarSeverity("error");
    } else {
      setLoading(true);
      const payload = {
        // facility_name: selectedFacilities,
        facility_name: [searchFacility?.id],
        first_name: searchFirstName,
        last_name: searchLastName,
        status: status,
        date_from: startDate ? formatDate(startDate) : null,
        date_to: endDate ? formatDate(endDate) : null,
        // "provider_id": searchFacility || endDate || startDate ? profileId : "",
        provider_id: selectedProviders,
        download_excel: false,
      };

      dispatch(
        getcopyDataSuperbill(
          payload,
          currentPage,
          (data) => {
            setLoading(false);
            setFilteredData(search === true ? data?.data?.results : []);
            setCounts(data?.data?.count);
            setSelectAll(false);
            // setSelectedRows([])
          },
          (error) => {
            console.log(error);
            setLoading(false);
          }
        )
      );
    }
  };

  // useEffect(() => {
  //   setLoading(true);
  //   const payload = null;
  //   dispatch(
  //     getAllFacilityTypes(
  //       payload,
  //       (data) => {
  //         setLoading(false);
  //         setFacilityTypeList(data?.data?.Data);
  //       },
  //       (error) => {
  //         console.log(error);
  //         setLoading(false);
  //       }
  //     )
  //   );
  // }, [updated]);

  useEffect(() => {
    // setLoading(true);
    const payload = null;
    dispatch(
      getFacilityByProviderId(
        payload,
        providerId,
        (data) => {
          setLoading(false);
          setFacilityList(data?.data?.Data);
        },
        (error) => {
          console.log(error);
          setLoading(false);
        }
      )
    );
  }, [updated]);

  useEffect(() => {
    if (!searchFacility) {
      // No facility selected → clear provider list
      setProviderList([]);
      setSelectedProviders([]); // also clear selected providers
      return;
    }

    // setLoading(true);
    const payload = { facility_ids: [searchFacility?.id], biller_id: "" };
    dispatch(
      getProviderListByFacility(
        payload,
        (data) => {
          setLoading(false);
          setProviderList(data?.data?.providers || []);
        },
        (error) => {
          console.log(error);
          setLoading(false);
        }
      )
    );
  }, [searchFacility]);

  const handleEdit = (newStatus) => {
    if (selectedFacility) {
      const updatedFacility = {
        ...selectedFacility,
        status: newStatus,
      };

      const updatedData = data.map((facility) =>
        facility.facilityCode === selectedFacility.facilityCode
          ? updatedFacility
          : facility
      );

      setData(updatedData);
      //   onEdit(updatedFacility);
      setAnchorEl(null);
    }
  };

  const handleDelete = () => {
    //   onDelete(selectedRows);
    setSelectedRows([]);
  };

  // useEffect(() => {
  //     setCurrentPage(1)
  // }, [searchProvider, searchFacility, searchFacility, searchFacilityType, searchFirstName, searchLastName])

  const handleClearSearch = () => {
    setSearchFirstName("");
    setSearchLastName("");
    setDateRange([null, null]);
    setSearchFacility(null);
    setSearchFacilityType(null);
    setSelectedFacilities([]);
    setSelectedProviders([]);
  };

  const handleSelectAllChange = (event) => {
    setSelectAll(event.target.checked);
    if (event.target.checked) {
      const allCodes = filteredData.map((row) => row.id);
      setSelectedRows(allCodes);
    } else {
      setSelectedRows([]);
    }
  };

  const handleChangePage = (event, newPage) => {
    setCurrentPage(newPage);
  };

  const startIndex = (currentPage - 1) * ROWS_PER_PAGE;
  const endIndex = startIndex + ROWS_PER_PAGE;

  function convertDateString(dateString) {
    // Create a Date object from the date string
    const date = new Date(dateString);

    // Extract the month, day, and year
    const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Months are zero-based
    const day = date.getDate().toString().padStart(2, "0");
    const year = date.getFullYear();

    // Format the date as MM/DD/YYYY
    return `${month}/${day}/${year}`;
  }

  useEffect(() => {
    // setCopyData([])

    const copyFilteredData = data;
    const mappedData = copyFilteredData?.map((row) => ({
      provider_profile: row.provider_profile?.id,
      facility_master: "",
      patient_name: row.patient_name,
      last_name: row.last_name,
      dob: row.dob,
      date_of_service: row.date_of_service,
      // cpt_code: row.cpt_code.split(","),
      cpt_code: "",
      dx_code: row.dx_code.split(", "),
      admission: row.admission,
      reason_for_visit: row.reason_for_visit,
      comment: row.comment,
      modifier: row.modifier,
      // state: row.state,
      facility_type: "",
      // state: row.state,
      // facility_type: row.facility_type,
    }));
    setCopyData(mappedData);
  }, [selectedRows, data]);

  const [sortOrder, setSortOrder] = useState("desc");

  const handleSort = () => {
    const order = sortOrder === "asc" ? "desc" : "asc"; // Toggle sort order
    setSortOrder(order); // Update the sort order state

    // Sorting function based on the current order
    const sorted = [...filteredData].sort((a, b) => {
      const lastNameA = a?.last_name?.toUpperCase() || ""; // Handle undefined or null values
      const lastNameB = b?.last_name?.toUpperCase() || "";

      if (lastNameA < lastNameB) return order === "asc" ? -1 : 1;
      if (lastNameA > lastNameB) return order === "asc" ? 1 : -1;
      return 0;
    });

    setFilteredData(sorted); // Update the sorted data state
  };

  const handleSortFirstName = () => {
    const order = sortOrder === "asc" ? "desc" : "asc"; // Toggle sort order
    setSortOrder(order); // Update the sort order state

    // Sorting function based on the current order
    const sorted = [...filteredData].sort((a, b) => {
      const firstNameA = a?.patient_name?.toUpperCase() || ""; // Handle undefined or null values
      const firstNameB = b?.patient_name?.toUpperCase() || "";

      if (firstNameA < firstNameB) return order === "asc" ? -1 : 1;
      if (firstNameA > firstNameB) return order === "asc" ? 1 : -1;
      return 0;
    });

    setFilteredData(sorted); // Update the sorted data state
  };

  const handleSortByDate = () => {
    const order = sortOrder === "asc" ? "desc" : "asc"; // Toggle sort order
    setSortOrder(order); // Update the sort order state

    // Sorting function based on the current order
    const sorted = [...filteredData].sort((a, b) => {
      const dateA = new Date(a?.date_of_service);
      const dateB = new Date(b?.date_of_service);

      if (dateA < dateB) return order === "asc" ? -1 : 1;
      if (dateA > dateB) return order === "asc" ? 1 : -1;
      return 0;
    });

    setFilteredData(sorted); // Update the sorted data state
  };

  const commonInputSx = {
    // width:"100% !important",
    // minWidth:"10rem !important",
    "& .MuiOutlinedInput-root": {
      minHeight: "2rem !important",
      height: "100% !important",
      fontSize: "12px",
      padding: "4px 10px !important",
    },
    "& .MuiOutlinedInput-input": {
      padding: "0px !important",
      fontSize: "12px",
    },
    "& .MuiAutocomplete-root": {
      height: "1.5rem !important",
    },
  };

  return (
    <div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Box
          className="scrollBar-Y scrollBar"
          style={{
            backgroundColor: "#fff",
            boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
            padding: "20px",
            outline: "none",
            minHeight: "90vh",
            maxHeight: "90vh",
            width: "90vw",
            maxWidth: "90vw",
            borderRadius: "16px",
            overflow: "auto", // Enable scrolling
          }}
        >
          <Box sx={{ px: 10, py: 2 }}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                verticalAlign: "middle",
              }}
            >
              <Typography
                variant="h6"
                sx={{ color: "rgba(29, 57, 105, 1)", fontWeight: "bold" }}
              >
                Search (Copy Data)
              </Typography>
              <IconButton onClick={handleClose}>
                <CloseIcon />
              </IconButton>
            </Box>
            <Grid container spacing={2} sx={{ py: 4 }}>
              <Grid item xs={12} sm={6} md={6} lg={6}>
                <InputLabel>Facility Name</InputLabel>
                <Autocomplete
                  className="scrollBar"
                  fullWidth
                  value={searchFacility}
                  onChange={(event, newValue) => {
                    setSearchFacility(newValue);
                  }}
                  // sx={{ width: '15vw !important' }}
                  clearIcon={null}
                  options={facilityList} // Pass the array directly
                  getOptionLabel={(option) => option.facility_name}
                  getOptionSelected={(option, value) =>
                    option.facility_name === value.facility_name
                  }
                  isOptionEqualToValue={(option, value) =>
                    option.facility_name === value.facility_name
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      sx={{ "& input": { height: "0px", fontSize: "14px" } }}
                    />
                  )}
                />

                {/* <Autocomplete
                  multiple
                  disableCloseOnSelect
                  // options={
                  //   facilityList.length > 0
                  //     ? [
                  //         {
                  //           id: "ALL",
                  //           facility_name: "Select All",
                  //           facility_code: "",
                  //         },
                  //         ...facilityList,
                  //       ]
                  //     : [] // ✅ no options when list is empty
                  // }
                  options={facilityList}
                  getOptionLabel={(option) => option.facility_name}
                  value={facilityList.filter((f) =>
                    selectedFacilities.includes(f.id)
                  )}
                  onChange={(e, newValue) => {
                    const hasAll = newValue.some((v) => v.id === "ALL");
                    const allSelected =
                      selectedFacilities.length === facilityList.length;

                    if (hasAll) {
                      if (allSelected) {
                        setSelectedFacilities([]); // ✅ deselect all
                      } else {
                        setSelectedFacilities(facilityList.map((f) => f.id)); // ✅ select all
                      }
                    } else {
                      setSelectedFacilities(newValue.map((f) => f.id));
                    }
                  }}
                  renderTags={(value, getTagProps) =>
                    value.map((option, index) => (
                      <Chip
                        {...getTagProps({ index })}
                        label={`${option.facility_name} ${
                          option.facility_code
                            ? `(${option.facility_code})`
                            : ""
                        }`}
                        size="small"
                        sx={{ fontSize: "12px", height: 22 }}
                      />
                    ))
                  }
                  renderOption={(props, option, { selected }) => (
                    <li {...props}>
                      <Checkbox
                        icon={icon}
                        checkedIcon={checkedIcon}
                        style={{ marginRight: 8 }}
                        checked={
                          option.id === "ALL"
                            ? selectedFacilities.length === facilityList.length
                            : selected
                        }
                      />
                      {option.facility_name}{" "}
                      {option.facility_code && `(${option.facility_code})`}
                    </li>
                  )}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      // sx={{
                      //   "& input": { height: "18px !important", fontSize: "14px" },
                      // }}
                      sx={commonInputSx}
                    />
                  )}
                /> */}
                
              </Grid>

              <Grid item xs={12} sm={6} md={6} lg={6}>
                <InputLabel>Provider</InputLabel>
                <Autocomplete
                  multiple
                  disableCloseOnSelect
                  options={
                    providerList.length > 0
                      ? [{ id: "ALL", name: "Select All" }, ...providerList]
                      : []
                  }
                  getOptionLabel={(option) => option.name}
                  value={providerList.filter((p) =>
                    selectedProviders.includes(p.id)
                  )}
                  onChange={(e, newValue) => {
                    const hasAll = newValue.some((v) => v.id === "ALL");
                    const allSelected =
                      selectedProviders.length === providerList.length;

                    if (hasAll) {
                      if (allSelected) {
                        setSelectedProviders([]); // ✅ deselect all
                      } else {
                        setSelectedProviders(providerList.map((p) => p.id)); // ✅ select all
                      }
                    } else {
                      setSelectedProviders(newValue.map((p) => p.id));
                    }
                  }}
                  renderTags={(value, getTagProps) =>
                    value.map((option, index) => (
                      <Chip
                        {...getTagProps({ index })}
                        label={option.name}
                        size="small"
                        sx={{ fontSize: "12px", height: 22 }}
                      />
                    ))
                  }
                  renderOption={(props, option, { selected }) => (
                    <li {...props}>
                      <Checkbox
                        icon={icon}
                        checkedIcon={checkedIcon}
                        style={{ marginRight: 8 }}
                        checked={
                          option.id === "ALL"
                            ? selectedProviders.length === providerList.length
                            : selected
                        }
                      />
                      {option.name}
                    </li>
                  )}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      sx={commonInputSx}
                    />
                  )}
                />
              </Grid>

             

              <Grid item md={3} xs={6}>
                <InputLabel
                  sx={{
                    display: "flex",
                    justifyContent: "left",
                    alignItems: "center",
                    verticalAlign: "middle",
                  }}
                >
                  Patient{" "}
                  <Typography sx={{ fontWeight: "bold", mx: 1 }}>
                    {" "}
                    First{" "}
                  </Typography>{" "}
                  Name
                </InputLabel>
                <CustomTextField
                  value={searchFirstName}
                  setValue={setSearchFirstName}
                />
              </Grid>

               <Grid item md={3} xs={6}>
                <InputLabel
                  sx={{
                    display: "flex",
                    justifyContent: "left",
                    alignItems: "center",
                    verticalAlign: "middle",
                  }}
                >
                  Patient{" "}
                  <Typography sx={{ fontWeight: "bold", mx: 1 }}>
                    {" "}
                    Last{" "}
                  </Typography>{" "}
                  Name
                </InputLabel>
                <CustomTextField
                  value={searchLastName}
                  setValue={setSearchLastName}
                />
              </Grid>

              <Grid item md={3} xs={6}>
                <InputLabel id="facility-type-label">
                  Date of Service (From)
                </InputLabel>
                <DatePicker
                  selected={startDate}
                  onChange={(date) => setDateRange([date, endDate])}
                  isClearable={true}
                  selectsStart
                  startDate={startDate}
                  endDate={endDate}
                  className="reactDateRangePicker3"
                  minDate={
                    new Date(new Date().setDate(new Date().getDate() - 60))
                  }
                  maxDate={new Date()} // today
                />
              </Grid>

              <Grid item md={3} xs={6}>
                <InputLabel id="facility-type-label">
                  Date of Service (To)
                </InputLabel>
                <DatePicker
                  // placeholderText='Select End Date'
                  selected={endDate}
                  onChange={(date) => setDateRange([startDate, date])}
                  isClearable={true}
                  className="reactDateRangePicker3"
                  selectsEnd
                  startDate={startDate}
                  endDate={endDate}
                  //   minDate={startDate}
                  minDate={
                    new Date(new Date().setDate(new Date().getDate() - 60))
                  }
                  maxDate={new Date()} // today
                />
              </Grid>
            </Grid>

            <Box
              sx={{
                display: "flex",
                justifyContent: "right",
                alignItems: "right",
              }}
            >
              <Button
                className="buttonPadding"
                variant="contained"
                onClick={handleClearSearch}
                sx={{ boxShadow: "none !important", mr: 1 }}
              >
                Clear
              </Button>

              <Button
                className="buttonPadding"
                variant="contained"
                onClick={handleSearch}
                sx={{ boxShadow: "none !important" }}
              >
                Search
              </Button>
            </Box>

            {loading ? (
              <Box
                sx={{
                  minHeight: "40vh",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <CircularProgress
                  sx={{ color: "rgba(29, 57, 105, 1) !important" }}
                />
              </Box>
            ) : filteredData?.length === 0 ? (
              <Typography
                variant="body2"
                sx={{ textAlign: "center", color: "#555", mt: 15 }}
              >
                No Data Available
              </Typography>
            ) : (
              <Box sx={{ my: 4 }}>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    mb: 3,
                  }}
                >
                  <Typography
                    variant="h6"
                    sx={{ color: "rgba(29, 57, 105, 1)", fontWeight: "bold" }}
                  >
                    Data
                  </Typography>
                  {/* <Button
                                                sx={{
                                                    float: 'right',
                                                    boxShadow: 'none !important',
                                                    background: selectedRows.length === 0 ? '#d2d2d2' : 'rgba(29, 57, 105, 1) !important',

                                                }}
                                                variant="contained"
                                                onClick={handleDownloadExcel}
                                                disabled={selectedRows.length === 0}
                                            >
                                                Download Excel
                                            </Button> */}

                  <Button
                    sx={{
                      float: "right",
                      boxShadow: "none !important",
                      background: selectedRows.length === 0 ? "#d2d2d2" : null,
                      float: "right",
                      mt: 2,
                    }}
                    variant="contained"
                    onClick={handleCopyData}
                    disabled={selectedRows.length === 0}
                  >
                    Copy Data
                  </Button>
                </Box>

                <TableContainer
                  className="scrollBar table-container"
                  component={Paper}
                >
                  <Table className="custom-table  ">
                    <TableHead sx={{ background: "rgba(29, 57, 105, 1)" }}>
                      <TableRow>
                        <TableCell sx={{ color: "#fff", py: 0.5 }}>
                          {/* <Checkbox
                                                                checked={selectAll}
                                                                onChange={handleSelectAllChange}
                                                                style={{ color: '#fff' }}
                                                            /> */}
                        </TableCell>
                       
                        {/* <TableCell sx={{ color: "#fff", py: 1, whiteSpace: 'nowrap' }} >State</TableCell> */}
                         <TableCell
                          sx={{ color: "#fff", py: 1, whiteSpace: "nowrap" }}
                        >
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              verticalAlign: "middle",
                            }}
                          >
                            <Typography>First Name</Typography>
                            <IconButton onClick={handleSortFirstName}>
                              <SwapVertIcon sx={{ color: "#fff" }} />
                            </IconButton>
                          </Box>
                        </TableCell>
                        <TableCell
                          sx={{ color: "#fff", py: 1, whiteSpace: "nowrap" }}
                        >
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              verticalAlign: "middle",
                            }}
                          >
                            <Typography>Last Name</Typography>
                            <IconButton onClick={handleSort}>
                              <SwapVertIcon sx={{ color: "#fff" }} />
                            </IconButton>
                          </Box>
                        </TableCell>
                       
                        <TableCell
                          sx={{ color: "#fff", py: 1, whiteSpace: "nowrap" }}
                        >
                          Date of Birth
                        </TableCell>
                        <TableCell
                          sx={{ color: "#fff", py: 1, whiteSpace: "nowrap" }}
                        >
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              verticalAlign: "middle",
                            }}
                          >
                            <Typography>Date of Service</Typography>
                            <IconButton onClick={handleSortByDate}>
                              <SwapVertIcon sx={{ color: "#fff" }} />
                            </IconButton>
                          </Box>
                        </TableCell>
                        <TableCell
                          sx={{ color: "#fff", py: 1, whiteSpace: "nowrap" }}
                        >
                          CPT Code
                        </TableCell>
                        <TableCell
                          sx={{ color: "#fff", py: 1, whiteSpace: "nowrap" }}
                        >
                          DX Code
                        </TableCell>
                        <TableCell
                          sx={{ color: "#fff", py: 1, whiteSpace: "nowrap" }}
                        >
                          Admission
                        </TableCell>
                        <TableCell
                          sx={{ color: "#fff", py: 1, whiteSpace: "nowrap" }}
                        >
                          Reason for Visit
                        </TableCell>
                        <TableCell
                          sx={{ color: "#fff", py: 1, whiteSpace: "nowrap" }}
                        >
                          Comment
                        </TableCell>
                        <TableCell
                          sx={{ color: "#fff", py: 1, whiteSpace: "nowrap" }}
                        >
                          Modifier
                        </TableCell>
                        <TableCell sx={{ color: "#fff", py: 1 }}>
                          Status
                        </TableCell>
                         <TableCell
                          sx={{ color: "#fff", py: 1, whiteSpace: "nowrap" }}
                        >
                          Provider
                        </TableCell>
                        <TableCell
                          sx={{ color: "#fff", py: 1, whiteSpace: "nowrap" }}
                        >
                          Facility
                        </TableCell>
                        <TableCell
                          sx={{ color: "#fff", py: 1, whiteSpace: "nowrap" }}
                        >
                          Facility Type
                        </TableCell>
                        <TableCell sx={{ color: "#fff", py: 1 }}>
                          Biller
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {(filteredData ? [...filteredData].reverse() : []).map(
                        (row, index) => (
                          <TableRow key={index}>
                            <TableCell sx={{ py: 0.5 }}>
                              <Checkbox
                                checked={selectedRows?.includes(row.id)}
                                onChange={() => handleCheckboxChange(row.id)}
                                style={{ color: "rgba(29, 57, 105, 1)" }}
                              />
                            </TableCell>
                          
                            {/* <TableCell className='fs12' sx={{ whiteSpace: 'nowrap' }}>{row?.state?.state_Name}</TableCell> */}
                           
                            <TableCell
                              className="fs12"
                              sx={{ whiteSpace: "nowrap" }}
                            >
                              {row?.patient_name}
                            </TableCell>
                             <TableCell
                              className="fs12"
                              sx={{ whiteSpace: "nowrap" }}
                            >
                              {row?.last_name}
                            </TableCell>
                            <TableCell
                              className="fs12"
                              sx={{ whiteSpace: "nowrap" }}
                            >
                              {row?.dob}
                            </TableCell>
                            <TableCell
                              className="fs12"
                              sx={{ whiteSpace: "nowrap" }}
                            >
                              {row?.date_of_service}
                            </TableCell>
                            <TableCell
                              className="fs12"
                              sx={{ whiteSpace: "nowrap" }}
                            >
                              {row?.cpt_code}
                            </TableCell>
                            <TableCell
                              className="fs12"
                              sx={{ whiteSpace: "nowrap" }}
                            >
                              {row?.dx_code}
                            </TableCell>
                            <TableCell
                              className="fs12"
                              sx={{ whiteSpace: "nowrap" }}
                            >
                              {row?.admission}
                            </TableCell>
                            <TableCell
                              className="fs12"
                              sx={{ whiteSpace: "nowrap" }}
                            >
                              {row?.reason_for_visit}
                            </TableCell>
                            <TableCell
                              className="fs12"
                              sx={{ whiteSpace: "nowrap" }}
                            >
                              {row?.comment}
                            </TableCell>
                            <TableCell
                              className="fs12"
                              sx={{ whiteSpace: "nowrap" }}
                            >
                              {row?.modifier}
                            </TableCell>
                            <TableCell
                              className="fs12"
                              sx={{ whiteSpace: "nowrap" }}
                            >
                              {row?.is_status}
                            </TableCell>
                              <TableCell
                              className="fs12"
                              sx={{ whiteSpace: "nowrap" }}
                            >
                              {row?.provider_profile?.First_Name +
                                " " +
                                row.provider_profile?.Last_Name}
                            </TableCell>
                            <TableCell
                              className="fs12"
                              sx={{ whiteSpace: "nowrap" }}
                            >
                              {row?.facility_master?.facility_name}
                            </TableCell>
                            <TableCell
                              className="fs12"
                              sx={{ whiteSpace: "nowrap" }}
                            >
                              {row?.facility_type?.facility_type_Name}
                            </TableCell>
                            <TableCell
                              className="fs12"
                              sx={{ whiteSpace: "nowrap" }}
                            >
                              {row?.biller_profile !== null
                                ? row?.biller_profile?.First_Name +
                                  " " +
                                  row?.biller_profile?.Last_Name
                                : ""}
                            </TableCell>
                          </TableRow>
                        )
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>

                <CustomPagination
                  count={Math.ceil(counts / ROWS_PER_PAGE)}
                  page={currentPage}
                  onChange={handleChangePage}
                />
              </Box>
            )}

            <Menu
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={handleEditClose}
            >
              <MenuItem onClick={() => handleEdit("Active")}>Active</MenuItem>
              <MenuItem onClick={() => handleEdit("Inactive")}>
                Inactive
              </MenuItem>
            </Menu>
          </Box>
        </Box>
      </Modal>
    </div>
  );
};

export default CopyDataModal;
